import { IJsonQuery } from '@cian/api-models/common/json_query';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IContext, EFrequency } from '@cian/save-search-widget';
import { ModalWindow } from '@cian/ui-kit/modal';
import loadable from '@loadable/component';
import * as React from 'react';

import { WidgetFallback } from './components/WidgetFallback';
import { WidgetErrorBoundary } from './components/WidgetErrorBoundary';
import * as styles from './SaveSearchModal.css';

const SaveSearchWidgetLoadable = loadable.lib(() => import('@cian/save-search-widget'), {
  fallback: <WidgetFallback />,
});

export interface ISaveSearchModalProps {
  userEmail: string | null;
  hideLicense?: boolean;
  subdomain: string;
  jsonQuery: IJsonQuery;
  httpApi: IHttpApi;
  logger: ILogger;
  isOpen: boolean;
  onOpen?(): void;
  onClose(): void;
}

export class SaveSearchModal extends React.Component<ISaveSearchModalProps> {
  private widgetContext: IContext | null;

  public componentDidUpdate(prevProps: ISaveSearchModalProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.onOpen) {
        this.props.onOpen();
      } else {
        this.widgetContext = null;
      }
    }
  }

  public render() {
    const { userEmail, hideLicense, subdomain, jsonQuery, isOpen, httpApi, logger, onClose } = this.props;

    return (
      <ModalWindow
        open={isOpen}
        onClose={onClose}
        title="Сохранение поиска"
        content={
          <div className={styles['container']}>
            <WidgetErrorBoundary logger={logger} onRetry={this.onRetry}>
              <SaveSearchWidgetLoadable>
                {({ createContext, Provider, SaveSearch }) => {
                  if (!this.widgetContext) {
                    this.widgetContext = createContext({
                      subdomain,
                      httpApi,
                      logger,
                    });
                  }

                  return (
                    <Provider context={this.widgetContext}>
                      <SaveSearch
                        jsonQuery={jsonQuery}
                        defaultFrequency={EFrequency.Hourly}
                        defaultEmail={userEmail || undefined}
                        defaultSubscribeToNews={true}
                        hideLicense={hideLicense}
                      />
                    </Provider>
                  );
                }}
              </SaveSearchWidgetLoadable>
            </WidgetErrorBoundary>
          </div>
        }
      />
    );
  }

  private onRetry = () => {
    SaveSearchWidgetLoadable.load();
  };
}
